import React, {useState} from 'react';
import { doc,deleteDoc } from "firebase/firestore";
import db from '../firebase/firebaseConfig'
import {BotonBorrar, Parrafos} from './css/estilos'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark} from '@fortawesome/free-solid-svg-icons'
import 'bootstrap/dist/css/bootstrap.min.css';

const SalaDeChat = ({id,nombre,mensaje}) => {

    const eliminarMensaje = async (id) => {
        try {
            await deleteDoc(doc(db, 'datos-1', id)); // upDatedoc es asincrona (async y await) - dos parametros / doc - tres parametros.
        } catch(error){
            console.log('Hubo un error al intentar eliminar el usuario')
            console.log(error)
        };
    }

    return ( 
        <Parrafos key={id}>
            <p style={{margin: "0"}}>{mensaje}</p>
            <BotonBorrar onClick={() => eliminarMensaje(id)}>
                <FontAwesomeIcon icon={faXmark} />
            </BotonBorrar>
        </Parrafos>
     );
}
 
export default SalaDeChat;